var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ff0000",
    stroke: "#ff0000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#ff0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 -1 0 17 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.5 11.5 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 5.5 6 6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIcn);
export default __webpack_public_path__ + "static/media/circleIcn.81b3e81a46538a68a2153729200c7f4e.svg";
export { ForwardRef as ReactComponent };